/**
 * Shared scroll-triggered animation system for workshop blocks.
 * Custom Element <workshop-animate> observes children with [data-animate]
 * and adds .is-visible when they enter the viewport.
 *
 * Usage:
 *   <workshop-animate>
 *     <div data-animate data-delay="0">...</div>
 *     <div data-animate data-delay="100">...</div>
 *   </workshop-animate>
 *
 * Respects prefers-reduced-motion — instantly shows all elements.
 */
if (!customElements.get('workshop-animate')) {
  class WorkshopAnimate extends HTMLElement {
    constructor() {
      super();
      this._observer = null;
    }

    connectedCallback() {
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const targets = this.querySelectorAll('[data-animate]');

      if (prefersReduced) {
        targets.forEach(function (el) {
          el.classList.add('is-visible');
        });
        return;
      }

      this._observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var el = entry.target;
              var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
              setTimeout(function () {
                el.classList.add('is-visible');
              }, delay);
              this._observer.unobserve(el);
            }
          }.bind(this));
        }.bind(this),
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );

      targets.forEach(function (el) {
        this._observer.observe(el);
      }.bind(this));
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }
  }

  customElements.define('workshop-animate', WorkshopAnimate);
}
